import { render, staticRenderFns } from "./stay-page.vue?vue&type=template&id=8ecf0f68&"
import script from "./stay-page.vue?vue&type=script&lang=js&"
export * from "./stay-page.vue?vue&type=script&lang=js&"
import style0 from "./stay-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports